const getResolverPlaceholder = (imageSrc, resolverSettings) => {
    const resolverPlaceholderArray = imageSrc === null || imageSrc === void 0 ? void 0 : imageSrc.split('?');
    if ((resolverPlaceholderArray === null || resolverPlaceholderArray === void 0 ? void 0 : resolverPlaceholderArray.length) && resolverSettings) {
        const { width, height } = resolverSettings;
        const resolverPlaceholderParams = `blank=width[${width}],height[${height}],color[none]&sink=format[gif]`;
        resolverPlaceholderArray[1] = resolverPlaceholderParams;
        return resolverPlaceholderArray === null || resolverPlaceholderArray === void 0 ? void 0 : resolverPlaceholderArray.join('?');
    }
    return '';
};
export default getResolverPlaceholder;
//# sourceMappingURL=getResolverPlaceholder.js.map